__webpack_require__.p = "/synesthesia-gatsby-digital-garden/";